import React from "react";
import { Modal, Typography } from "antd";
import { GeneratedModelTypes } from "../../../../utilities/types/ModelsTypes";
import { useNavigate } from "react-router-dom";
import { Image } from "react-bootstrap";
import EditIcon from "../../../../assets/icons/edit-active.svg";
import viewIcon from "../../../../assets/icons/eyeOpened.svg";
import ChatWhiteIcon from "../../../../assets/icons/chat-white.svg";
import { ROUTES } from "../../../../utilities/Constants/Constants";
import { useTranslation } from "react-i18next";
import { TruncatedModalTitle } from "../../TruncatedModalTitle";
import { useModalContainer } from "../../../../utilities/Models/modelUtils";

interface WorkFlowPageLinkDeciderModalProps {
  model: GeneratedModelTypes;
  isVisible: boolean;
  onChange: () => void;
  onGetURL: (key: any) => void;
}

const WorkFlowPageLinkDeciderModal = ({
  model,
  isVisible,
  onChange,
  onGetURL,
}: WorkFlowPageLinkDeciderModalProps) => {
  const { t } = useTranslation("common");
  const navigate = useNavigate()
  const modalContainer = useModalContainer();

  const handleEditClick = () => {
    sessionStorage.setItem("secret_key", model?.secret_key);
    // const myData = { model: model };
    // const newTab: any = window.open(ROUTES.WORK_BENCH, '_blank');
    // const handleReady = (event: any) => {
    //   if (event.origin !== window.location.origin) return;
    //   if (event.data?.type === 'message-ready') {
    //     newTab.postMessage(myData, window.location.origin);
    //     window.removeEventListener('message', handleReady);
    //   }
    // };
    // window.addEventListener('message', handleReady);
    navigate(ROUTES.WORK_BENCH)
    onChange?.();
    // sessionStorage.removeItem('secret_key');
  };

  return (
    <Modal
      title={false}
      footer={false}
      centered
      open={isVisible}
      onCancel={onChange}
      className="upload-modal"
      width={500}
      styles={{ body: { padding: "20px" } }}
      mask={false}
      getContainer={() => modalContainer || document.body}
    >
      <TruncatedModalTitle title={model.filename} />
      <div className="d-flex justify-content-center gap-4 my-4">
        {(model?.file_type === "1" || model?.file_type === "viewport") && (
          <div className="d-flex flex-column align-items-center gap-2">
            <div
              onClick={handleEditClick}
              className="p-3 workflow-custom-link"
              role="button"
              tabIndex={0}
            >
              <Image src={model?.permission === 1 ? viewIcon : EditIcon} width={30} />
            </div>
            <Typography.Text className="redirect-modal-button-text">
              {model?.permission === 1 ? t("buttons.view") : t("buttons.edit")}
            </Typography.Text>
          </div>
        )}
        <div className="d-flex flex-column align-items-center gap-2">
          <button
            onClick={() => { onGetURL(model?.secret_key); onChange() }}
            className="p-3 workflow-custom-link"
          >
            <Image src={ChatWhiteIcon} width={30} />
          </button>
          <Typography.Text className="redirect-modal-button-text">{t('buttons.chat')}</Typography.Text>
        </div>
      </div>
    </Modal>
  );
};

export default WorkFlowPageLinkDeciderModal;
